module.exports = __webpack_public_path__ + "img/NIO.d6618b9b.svg";